import { render } from "./hiddenHotspot.vue?vue&type=template&id=4dd65efd"
import script from "./hiddenHotspot.vue?vue&type=script&lang=js"
export * from "./hiddenHotspot.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__